<router-outlet></router-outlet>
<img class="background background--bottom" [src]="bg1tireImageUrl" />
<img class="background background--top" [src]="bg2tireImageUrl" />
